import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames(
  'flex',
  'flex-col',
  'justify-center',
  'text-center',
  'items-center',
  'pr-3'
);

interface Props {
  children: ReactNode;
  icon?: Icon;
}

const CardSocial = ({ children, icon }: Props) => (
  <div className="flex flex-row">
    <div className={className} data-testid="card-social-icon">
      <div className="mb-1 text-card-title-color">
        <IconView icon={icon} size={'2xl'} />
      </div>
    </div>
    <div>{children}</div>
  </div>
);

export default CardSocial;
